import { useGetUserNotificationPreferencesQuery } from '../graphql/GetUserNotificationPreferences.generated';

// ─────────────────────────────────────────────────────────────────────

export const useNotificationPreferencesState = () => {
  const [{ fetching, error, data }, refetch] =
    useGetUserNotificationPreferencesQuery();

  const resolvedData = data?.getUserNotificationPreferences;
  const hasValidPreferences = resolvedData?.__typename === 'UserNotificationPreferences'; // prettier-ignore

  return {
    loading: fetching,
    error,
    refetch,
    preferences: hasValidPreferences
      ? resolvedData.notificationCategories
      : null,
  };
};
